import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../core/services';
import { ApiResponse } from '../../../core/models';
import {
  LocationOptionDTO,
  PostalCodeOptionDTO,
} from '../../models/shared.model';
import { LocationsRepository } from '../contracts/locations.repository';

@Injectable({
  providedIn: 'root',
})
export class LocationsHttpRepository extends BaseApiService implements LocationsRepository {
  private readonly controllerUrl = '/Locations/';

  listCountries(): Observable<HttpResponse<ApiResponse<LocationOptionDTO[]>>> {
    return this.http.post<ApiResponse<LocationOptionDTO[]>>(
      `${this.baseUrl}${this.controllerUrl}country-list`,
      null,
      { observe: 'response' },
    );
  }

  listStatesByCountry(
    countryId: string,
  ): Observable<HttpResponse<ApiResponse<LocationOptionDTO[]>>> {
    return this.http.get<ApiResponse<LocationOptionDTO[]>>(
      `${this.baseUrl}${this.controllerUrl}get-states-by-country/${encodeURIComponent(countryId)}`,
      { observe: 'response' },
    );
  }

  listCitiesByState(
    stateId: string,
  ): Observable<HttpResponse<ApiResponse<LocationOptionDTO[]>>> {
    return this.http.get<ApiResponse<LocationOptionDTO[]>>(
      `${this.baseUrl}${this.controllerUrl}get-cities-by-state/${encodeURIComponent(stateId)}`,
      { observe: 'response' },
    );
  }

  listPostalCodesByCity(
    cityId: string,
  ): Observable<HttpResponse<ApiResponse<PostalCodeOptionDTO[]>>> {
    return this.http.get<ApiResponse<PostalCodeOptionDTO[]>>(
      `${this.baseUrl}${this.controllerUrl}get-postal-codes-by-city/${encodeURIComponent(cityId)}`,
      { observe: 'response' },
    );
  }
}
